<template>
<v-row justify="center" class="my-10" :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
    <v-col md="4">
      <v-row>
        <v-col align="start">
          <h2 class="primary--text" style="font-family: Avenir1;">Have questions?</h2> <br/>
          <p class="headers1"> Frequently Asked Questions </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="par">
          <p class="balck--text">
            We pride ourselves on transparency and great customer service, which is why no questions go unanswered.
          </p>
          <br/>
          <p>
            <span style="font-weight: bold; font-size: 22px;"> Have more questions? Call Us </span>
            <a class="primary--text" href="tel:+27722459777" style="text-decoration: none;" @click="trackPhone"> 072 245 9777</a>
          </p>
        </v-col>
      </v-row>
      <v-row>
        <GmapMap
          :center="center"
          :zoom="this.$vuetify.breakpoint.smAndDown ? 4.3 : 5"
          class="map"
          :options="{
            mapTypeControl: false,
            streetViewControl: false,
            disableDefaultUI: true
          }"
          style="width: 100%; height: 350px;"
          >
          <GmapMarker
            v-for="(position, index) in driverLocations"
            :key="index"
            :position="position"
            :icon="'truck_pin.png'"
          />
        </GmapMap>
      </v-row>
    </v-col>
    <v-col align="right" md="6" class="par">
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              How to book?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text" class="exp">
              <v-row justify="center">
                <v-col align="start">
                  <ul class="white--text mt-5">
                      <li> Sign up in 60 seconds with your card or EFT. </li>
                      <li> Enter your waste location. </li>
                      <li> Book different waste types & various products for multiple locations on your dashboard. </li>
                  </ul>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              How does Dash Waste work?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text" class="exp">
              <br/>
              <HowItWorks/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              How do I pay?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text" class="exp">
              <Payment/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              How to get in contact?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text" class="exp">
              <ul class="secondary--text mt-4 text-start">
                <li> <a href="mailto:info@dashwaste.co.za" @click="trackEmail"> info@dashwaste.co.za </a> </li>
                <li> <a href="tel:+27722459777" @click="trackPhone"> 072 245 9777 </a> </li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              What areas do you service?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text" class="exp">
              <ul class="white--text mt-4 text-start">
                <li> Currently centers of Cape Town, Boland, Johannesburg & Pretoria. </li>
                <li> Enter your waste address in the quote flow to confirm availability for your postal code. </li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              What waste type to choose?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text" class="exp">
              <wasteType/>
              <ul class="white--text mt-4 text-start">
                <li v-for="service in services" :key="service.slug">
                  <router-link class="primary--text" :to="service.path">{{ service.name }}</router-link>
                </li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              What product to book?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text" class="exp">
              <serviceType/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              What size to book?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text" class="exp">
              <tonnage/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              How long can I keep the bin?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text" class="exp">
              <v-row justify="center">
                <v-col align="start">
                  <ul class="white--text mt-4">
                    <li> Bin rental for 1 - 7 days. </li>
                    <li> Contact us for monthly rentals. </li>
                  </ul>
              </v-col>
            </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              Your accredited partners?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="white white--text" class="exp">
              <v-row justify="center" id="step" class="pt-6 step">
                <v-col align="center">
                  <v-img
                  src="@/assets/IWM.png"
                  alt="Logo"
                  max-width="90"
                  contain
                  class="mb-1"
                  />
                  <br/>
                  <p class="main--text text-justify-center"> Institute of Waste Management since 2009 </p>
                </v-col>
                <v-col align="center" class="img">
                  <v-img
                  src="@/assets/City of Cape Town.png"
                  alt="Logo"
                  max-width="150"
                  contain
                  />
                  <br/>
                  <p class="main--text text-justify-center"> Accredited City of Cape Town Provider since 2016 </p>
                </v-col>
                <v-col align="center">
                  <v-img
                  src="@/assets/MBA.png"
                  alt="Logo"
                  max-width="98"
                  contain
                  class="mt-n2"
                  />
                  <br/>
                  <p class="main--text text-justify-center"> Master Builders and Allied Traders' Association since 2021 </p>
                </v-col>
                <v-col align="center">
                  <v-img
                  src="@/assets/Umthi.png"
                  alt="Logo"
                  max-width="74"
                  contain
                  class="mt-n2"
                  />
                  <br/>
                  <p class="main--text text-justify-center"> Umthi Initiatives since 2020 </p>
                </v-col>
                <v-col align="center">
                  <v-img
                  src="@/assets/PeachLogo.png"
                  alt="Logo"
                  max-width="105"
                  contain
                  class="mb-5"
                  />
                  <br/>
                  <p class="main--text text-justify-center"> Peach Payments gateaway since 2007 </p>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              What are the benefits?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text" class="exp">
              <benefitsFaqs/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel class="exp">
            <v-expansion-panel-header class="headers2 exp" color="cardColour white--text">
              How to become a service provider?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text" class="exp">
              <HowToBecomeDriver/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
    </v-col>
</v-row>

</template>
<script>
import HowItWorks from "@/components/howItWorks";
import Payment from "@/components/payment";
import wasteType from "@/components/wasteType";
import serviceType from "@/components/serviceType";
import benefitsFaqs from "@/components/benefits-faqs";
import tonnage from "@/components/tonnage";
import HowToBecomeDriver from "@/components/driver";
import seoContent from "@/content/seo-content";
import { trackContactClick } from "@/utils/analytics";
import { gmapApi } from 'vue2-google-maps';
import GmapMarker from 'vue2-google-maps/src/components/marker';
import { collection, getDocs, getFirestore, query, where } from "firebase/firestore";
const db = getFirestore();

export default {
    name: 'faqs',
    computed: {
      google: gmapApi,
    },
    components: {
        GmapMarker,
        wasteType,
        serviceType,
        tonnage,
        benefitsFaqs,
        HowToBecomeDriver,
        HowItWorks,
        Payment,
    },
    data() {
        return {
          services: seoContent.services,
          driverLocations: [
            {
              lat: -26.099764,
              lng: 28.152349
            },
            {
              lat: -26.187822,
              lng: 27.964296
            },
            {
              lat: -26.048176,
              lng: 27.959156
            },
            {
              lat: -26.012775,
              lng: 28.212116
            },
            {
              lat: -26.032043,
              lng: 27.966179
            },
            {
              lat: -26.012775,
              lng: 28.212116
            },
          ],
          center: {
            lat: -29.0999996,
            lng: 26.2166658
          }
        }

    },
    methods: {
      trackPhone(){
        trackContactClick('phone');
      },
      trackEmail(){
        trackContactClick('email');
      }
    },
    mounted(){
    scrollTo(0, 0);
    const q = query(collection(db, 'users'), where('scope', '==', 'driver'))
    getDocs(q)
    .then((snap) => {
      snap.forEach((u) => {
       if(u.data().lat && u.data().long){
          this.driverLocations.push({
            lat: u.data().lat,
            lng: u.data().long
          })
        }
      })
    })
  }
}
</script>
<style scoped>
.exp{
  border-radius: 20px;
}
.headers1{
  font-family: Avenir1;
  font-style: normal;
  font-weight: 750;
  font-size: 48px;
  line-height: 64px;
}
.headers2{
  font-family: Avenir3;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 20px;
  height: 80px;
}
.par{
  font-family: Avenir3;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}
.lastrow{
    margin-bottom: 2cm;
}
.image1{
    margin-top: -0.19cm;
}
.image2{
    margin-top: -0.19cm;
}
#how-it-works{
  border-radius: 26px;
}
@media only screen and (max-width: 580px){
    #main{
      padding-top: 1cm;
    }
    .lastrow{
        margin-bottom: 13cm;
    }
    #step{
    display: block;
  }
  .line-divider{
    display: none;
  }
  .br{
    display: none;
  }
  p, ul{
    text-align: left;
    margin-left: 0.5cm;
    margin-right: 0.5cm;
  }
  .par{
    text-align: center;
  }
  .android{
    display: block;
  }
  .apple{
    display: block;
  }
  .image1{
    margin-top: 0cm;
  }
  .image2{
    margin-top: 0cm;
    margin-left: 0cm;
  }
}

</style>
